import { useNavigate } from "react-router-dom";

import { useAdminSalute } from "@/hooks/useAdminShell";
import type { StatoServizio } from "@/hooks/useAgenteSalute";
import { cn } from "@/lib/utils";

const DOT: Record<StatoServizio, string> = {
  ok: "bg-emerald-500",
  warn: "bg-amber-500",
  err: "bg-red-500",
  sconosciuto: "bg-slate-300",
};

/** 5 semafori di salute globale (Email · Agente · AI · DB · Risorse). */
export function HealthStrip() {
  const { data } = useAdminSalute();
  const navigate = useNavigate();

  if (!data) return null;

  const vaiA = (id: string) =>
    id === "database" || id === "risorse"
      ? navigate("/admin/sistema")
      : navigate("/admin/agenti/aida?tab=salute");

  return (
    <div className="hidden items-center gap-1.5 lg:flex">
      {data.servizi.map((s) => (
        <button
          key={s.id}
          type="button"
          onClick={() => vaiA(s.id)}
          title={`${s.label}: ${s.stato}`}
          className={cn(
            "flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors hover:bg-muted",
            s.stato === "warn" && "border-amber-200 bg-amber-50 text-amber-800",
            s.stato === "err" && "border-red-200 bg-red-50 text-red-800",
          )}
        >
          <span className={cn("size-2 rounded-full", DOT[s.stato])} />
          {s.label}
        </button>
      ))}
    </div>
  );
}
